/** @jsxImportSource theme-ui */
import { Container, Heading } from 'theme-ui';
import EditBillingInformation from '@/containers/billingInformation/EditBillingInformation';

const EditBillingInformationPage = () => {
    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Edit Billing Information
            </Heading>
            <EditBillingInformation />
        </Container>
    );
};

export default EditBillingInformationPage;
